import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let payment_account_id = useDataValue({
    viewPath: props.viewPath,
    context: 'payor',
    path: 'payment_account_id',
  })
  let insured_id = useDataValue({
    viewPath: props.viewPath,
    context: 'payor',
    path: 'insured_id',
  })

  return {
    variables: {
      where: {
        transaction: {
          receivable: {
            payment_account_id: { _eq: payment_account_id },
            insured_id: insured_id ? { _eq: insured_id } : { _is_null: true },
          },
        },
      },
    },
  }
}
